const KEY = "__nav_intent";

export const rememberIntent = (route: string) => {
  try {
    sessionStorage.setItem(KEY, route);
  } catch {
    // 特に何もしない
  }
};

export const consumeIntent = (): string | null => {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) sessionStorage.removeItem(KEY);
    return v;
  } catch {
    return null;
  }
};

export const peekIntent = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};
